import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import notify from 'devextreme/ui/notify';
import {
    DxButtonComponent,
    DxDataGridComponent,
    DxDataGridModule,
    DxFormComponent,
    DxFormModule,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
} from 'devextreme-angular/ui/nested';
import { AccessType, AuthService, GlCodeGridViewDto, PermissionType } from '@services';
import { FilterPanelComponent } from '../../../../components/library/filter-panel/filter-panel.component';
import {
    FilterConfig,
    GridPageComponent,
} from '../../../common/grid-page.component';

@Component({
    selector: 'app-gl-codes',
    imports: [
        CommonModule,
        DxDataGridComponent,
        DxiColumnComponent,
        DxoHeaderFilterComponent,
        DxoScrollingComponent,
        DxButtonComponent,
        DxiItemComponent,
        DxDataGridModule,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoLoadPanelComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoFilterRowComponent,
        DxFormComponent,
        FilterPanelComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSelectionComponent,
        DxFormModule,
    ],
    templateUrl: './gl-codes.component.html',
})
export class GlCodesComponent extends GridPageComponent<GlCodeGridViewDto> implements OnInit {
    @ViewChild(DxDataGridComponent, { static: false }) grid!: DxDataGridComponent;
    @Input() offset: number = 100;
    private authService = inject(AuthService);

    protected override exportName: string = 'GL Codes Report';

    dataSource = this.dataSources.glCodes();
    clientDataSource: any[] = [];

    protected override filterConfig: FilterConfig[] = [
        { field: 'Code', op: 'contains' },
        { field: 'Description', op: 'contains' },
        { field: 'clientId', op: '=' },
    ];

    constructor() {
        super();
        this.init(GlCodeGridViewDto);
    }

    ngOnInit(): void {
        this.dataSources.glCodeClientOptions().load().then((clients: any) => {
                this.clientDataSource = clients;
            })
            .catch(() => {
                notify('Failed to load sites', 'error', 3000);
            });
    }

    addNew() {
        this.grid.instance.addRow();
    }

    onRowUpdating(e: any) {
        e.newData = Object.assign({}, e.oldData, e.newData);
    }

    onRowDblClick(e: any) {
        if (e.rowType === 'data' && this.canEdit) {
            e.component.editRow(e.rowIndex);
        }
    }

    get canEdit() {
        return this.authService.checkPermission(PermissionType.GlCodes, AccessType.Edit);
    }
}
